import { render, staticRenderFns } from "./ExpenseCategoryCreatePage.vue?vue&type=template&id=d59d9d26&"
import script from "./ExpenseCategoryCreatePage.vue?vue&type=script&lang=ts&"
export * from "./ExpenseCategoryCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports